module.exports = __webpack_public_path__ + "img/badge-4.378c39a1.png";